export default __webpack_public_path__ + "static/media/image_4.a53997a1.jpg";